import varsModule from './vars';

export default {
  namespaced: true,
  modules: {
    vars: varsModule,
  },
};
